export default __webpack_public_path__ + "maps-examples-show-hide-layer-thumbnail-480-ece7023eb9d0f91a40c2f18829f39236.webp";